<span class="app-progress-spinner__inner">
  <svg
    viewBox="22 22 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="44"
      cy="44"
      r="20.2"
      fill="none"
      stroke="currentColor"
      stroke-width="3.6"
    ></circle>
  </svg>
</span>
